
















































import { getMessengers } from '@/api/Remittances/remittances.api'
import MessengersCreateDialog from '@/components/Services/Remittances/Messengers/MessengersCreateDialog.vue'
import { Messenger, Params } from '@/utils/interfaces'
import { tableHandler } from '@/utils/mixins/tableHandler'
import ActionButton from '@/components/ActionButton.vue'
import UsersFilter from '@/components/Agency/Users/UsersFilter.vue'
import DetailsDialog from '@/components/Services/Remittances/Messengers/DetailsDialog.vue'
import BalanceLabel from '@/components/BalanceLabel.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TableSwitch from '~/components/TableSwitch.vue'

export default tableHandler<Messenger>().extend({
  components: {
    appMessengerFilter: UsersFilter,
    appMessengersCreateDialog: MessengersCreateDialog,
    appActionButton: ActionButton,
    appDetailsDialog: DetailsDialog,
    BalanceLabel,
    FlatCard,
    FlatTable,
    TableSwitch,
  },
  data() {
    return {
      getter: (params?: Params) =>
        getMessengers({
          ...params,
          not_self: true,
          role: 'AGENT',
          is_active: true,
          'hide-commission': 'true',
        }),
      headers: [
        {
          text: this.$t('username'),
          value: 'username',
        },
        {
          text: this.$t('email'),
          value: 'email',
        },
        {
          text: this.$t('balance'),
          value: 'balance',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
    }
  },
  // methods: {
  //   toggle(item: Messenger['messenger_configs']) {
  //     return toggleMessenger({
  //       is_active: item.is_active,
  //       uuid: item.uuid,
  //     } as any)
  //   },
  // },
})
